import cx from 'clsx';
import { atoms } from '../../css/atoms/atoms';
import * as styles from './useIconSvgClassName.css';
const iconDirections = ['up', 'up-right', 'right', 'right-down', 'down', 'down-left', 'left', 'left-up'];

const calculateDeg = (direction, directionZero) => {
  const index = iconDirections.findIndex(c => c === direction) - iconDirections.findIndex(c => c === directionZero);
  return index < 0 ? 360 + index * 45 : index * 45;
};

export const useIconSvgClassName = ({
  scale,
  grayscale,
  direction,
  fontColor
}, directionZero = 'down') => {
  const scaleDefault = typeof scale === 'number' ? scale : 1;
  const atomicClasses = atoms({
    color: fontColor
  });
  return cx(styles.iconographyBoxBase, styles.iconographyScale[scaleDefault], direction && [styles.direction[calculateDeg(direction, directionZero)], styles.transition], {
    [styles.grayscale]: grayscale
  }, atomicClasses);
};
//# sourceMappingURL=useIconSvgClassName.js.map